
export const loadScript = (url, callback, oHead) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback(url);
      }
    };
  } else {
    script.onload = function () {
      callback(url);
    };
  }
  oHead = oHead || document.getElementsByTagName('head')[0];
  oHead.insertBefore(script, oHead.firstChild);
};

export default loadScript;



// WEBPACK FOOTER //
// ./src/helper/loadscript.js